import { Mutator } from "final-form";

const makeMutators = <TValues = object, TInitialValues = Partial<TValues>>(): {
  [key: string]: Mutator<TValues, TInitialValues>;
} => ({
  setValue: ([name, value], state, { changeValue }) => {
    changeValue(state, name, () => value);
  },
});

export default makeMutators;
